module.exports = __webpack_public_path__ + "static/media/movie.174a80e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/movie.svg
// module id = 614
// module chunks = 0